<div class="collapse-block">
  <h5>{{ 'fence.installations.simple-installations' | translate }}</h5>

  <div class="materials-container">
    @for (installation of installations; track installation.id) {
      <div (click)="selectInstallation(installation)"
           [class.active]="isInstallationSelected(installation)"
           class="materials-card">
        <img [src]="baseImgURL + installation.icon.path" alt="installation-img" class="board-img" />
        <p class="board-title">{{ installation.name }}</p>
      </div>
    } @empty {
      <ng-casto-loader></ng-casto-loader>
    }
  </div>
</div>
